import { SvgIcon } from '@mui/material';

export default function SignatureIcon(props: any) {
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 18.55 16.51"
      style={{ width: `19px`, height: `17px`, color: `#383838`, ...props.style }}
    >
      <g>
        <path d="M7.08,13.61a.34.34,0,0,0-.31-.2.36.36,0,0,0-.32.2l-.24.48a.5.5,0,0,1-.67.23.51.51,0,0,1-.26-.3l-.52-1.58-.34,1a1.33,1.33,0,0,1-1.28.92H2.75a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h.38a.35.35,0,0,0,.34-.24L4,11.4a.75.75,0,0,1,1-.48.74.74,0,0,1,.48.48l.44,1.3a1.42,1.42,0,0,1,2,.29s.07.1.1.16a.36.36,0,0,0,.29.2V10.77l4-4V5.32H8a.76.76,0,0,1-.75-.75V.3H1a.75.75,0,0,0-.76.75h0V15.62a.76.76,0,0,0,.76.75H11.53a.75.75,0,0,0,.76-.75h0V14.36h-4A1.36,1.36,0,0,1,7.08,13.61Zm5.21-9.49a.75.75,0,0,0-.22-.53L9,.52A.79.79,0,0,0,8.46.3H8.27v4h4Zm-3,7.07v2.17h2.16l5.08-5.11L14.39,6.12Zm8.8-5.64-1-1a.8.8,0,0,0-1.13,0l-.85.86,2.13,2.13.85-.86A.79.79,0,0,0,18.08,5.55Z" />
      </g>
    </SvgIcon>
  );
}
